import flowIdManagment from "core/Utils/FlowIdManagment";
import { getUrlParams } from "core/Utils/getUrlParams";

export function setFlowIdAndUTMSourceHeaders(config) {
    try {
        const flowManagement = flowIdManagment();
        const flowId = flowManagement?.getFlowId();
        const utmSource = getUrlParams("utm_source");
        const origin = getUrlParams("origin");
        const clientId = getUrlParams("client_id");
        config.headers["x-utm-source"] = utmSource;

        if(origin){
            config.headers["x-utm-source"] = origin;
        } 
        if(clientId){
            config.headers["x-utm-source"] = clientId;
        }
    
        if (flowId) {
          config.headers["x-cred-flow-id"] = flowId;
        }             
        return config;
    } catch (error) {
        console.error(`HEADERS`, error);
        return config;
    }
}